import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MortarboardFill, PeopleFill } from 'react-bootstrap-icons';

// Hooks & Constants
import { titles } from '../constants/titles';
import { useScale } from './HeightScaler';
import { NAVIGATION_HEIGHT } from '../constants/global';

// Styles
import { Area } from '../styles/_app.style';
import { 
    Form, 
    FormActions, 
    FormArea, 
    Header2, 
    Name, 
    Tagline 
} from '../styles/login.style';
import {
    ChoiceCard,
    CardIcon,
    CardTitle,
    CardDescription,
    ChoicesWrapper,
    Separator,
} from '../styles/choice.style';
import { BookLogo } from '../components/common/BookLogo';
import { AuthSkyline } from '../components/common/AuthSkyline';



const RegisterChoice = () => {
    const { scale } = useScale();

    // Configuration for the cards
    const cardMinWidth = '260px';
    const wrapThreshold = '520px'; // When both cards can fit side by side

    return (
        <>
        <AuthSkyline />
        <Area css={{
            minHeight: `calc((100dvh / ${scale}) - ${NAVIGATION_HEIGHT})`,
            marginTop: NAVIGATION_HEIGHT,
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
        }}>
            <Helmet>
                <title>{titles.register}</title>
            </Helmet>

            <FormArea css={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: '1rem'
            }}>
                <Form
                    size="lg"
                    css={{
                        width: 'fit-content',
                        maxWidth: '55rem',
                        height: 'fit-content',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    {/* <Header2>
                        <Name>Tutee</Name>
                    </Header2> */}

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'max-content',
                            alignItems: 'center',
                            // marginBottom: '0.5rem',
                        }}>
                            <span style={{
                                fontWeight: 'bold',
                                fontSize: '1.8rem',
                                lineHeight: '1',
                                color: 'var(--colors-slate12, #1e293b)',
                                letterSpacing: '-0.5px',
                            }}>
                                tute
                            </span>
                            <div style={{ width: '100%', height: '16px', marginTop: '0.1rem' }}>
                                <BookLogo />
                            </div>
                        </div>

                    <Tagline style={{ marginBottom: '2rem', textAlign: 'center' }}>
                        Are you here to teach, or to find a tutor for your child?     
                    </Tagline>

                    <ChoicesWrapper >
                        {/* Tutor Card */}
                        <ChoiceCard 
                            to="/register/tutor" 
                        >
                            <CardIcon><MortarboardFill size={50} /></CardIcon>
                            <CardTitle>I'm a Tutor</CardTitle>
                            <CardDescription>
                                Sign up to offer lessons, manage your schedule, and connect with students.
                            </CardDescription>
                        </ChoiceCard>

                        {/* Responsive Separator */}
                        <Separator />

                        {/* Parent Card */}
                        <ChoiceCard 
                            to="/register/parent"
                        >
                            <CardIcon><PeopleFill size={50} /></CardIcon>
                            <CardTitle>I'm a Parent</CardTitle>
                            <CardDescription>
                                Sign up to find the best tutors, manage lessons, and track your child's progress.
                            </CardDescription>
                        </ChoiceCard>
                    </ChoicesWrapper>

                    <FormActions>
                        <Link to="/login">
                            Already have an account? Sign in here
                        </Link>
                    </FormActions>
                </Form>
            </FormArea>
        </Area>
        </>
    );
};

export default RegisterChoice;